// removed by extract-text-webpack-plugin
module.exports = {"board":"board","root":"root","controls":"controls","left":"left","up":"up","right":"right","down":"down","reset":"reset","level-indicator":"level-indicator","mdl-layout-item":"mdl-layout-item","mdl-layout__drawer-button":"mdl-layout__drawer-button","over-game":"over-game","mdl-dialog":"mdl-dialog","no-dialog":"no-dialog"};


//////////////////
// WEBPACK FOOTER
// ./src/block-fly/stylesheets/site.style.scss
// module id = 12
// module chunks = 2